export default __webpack_public_path__ + "images/b62fdcdbaccbf4a42066550d6343038f.png";